import { Controller, useFormContext } from 'react-hook-form';
import { AutoComplete, AutoCompleteProps, Input, Space, Typography } from 'antd';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { useState } from 'react';
import generateKey from '../../utils/generateKey';

interface FormAutoCompleteProps extends AutoCompleteProps {
  name: string;
  placeholder: string;
  onChange?: (value: string) => void;
}

interface FormAutoCompleteOptionProps {
  name: string;
  caption: string;
}

export const FormAutoCompleteOption = ({ name, caption }: FormAutoCompleteOptionProps) => {
  return (
    <>
      <Space direction="vertical" size="small">
        <Typography.Text>{name}</Typography.Text>
        <Typography.Text type="secondary">{caption}</Typography.Text>
      </Space>
    </>
  );
};

export const FormAutoComplete = ({
  name,
  children,
  placeholder,
  onSelect,
  onChange,
  ...props
}: FormAutoCompleteProps) => {
  const { control } = useFormContext();
  const [isFocused, setIsFocused] = useState(false);
  const [key, setKey] = useState('');
  const internalOnChange = (formHookOnChange: (value: string) => void) => (value: string) => {
    formHookOnChange(value);
    onChange && onChange(value);
  };
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <AutoComplete
          key={key}
          onSelect={onSelect}
          onChange={(value) => {
            internalOnChange(onChange)(value);
          }}
          onClear={() => onChange('')}
          onBlur={() => setKey(generateKey())}
          value={value}
          defaultActiveFirstOption={true}
          {...props}
        >
          <Input
            name={name}
            value={value}
            size="middle"
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            suffix={
              isFocused ? (
                <SearchOutlined style={{ fontSize: '13px', color: '#c6c6c6' }} />
              ) : (
                <DownOutlined style={{ fontSize: '13px', color: '#c6c6c6' }} />
              )
            }
            placeholder={placeholder}
          />
        </AutoComplete>
      )}
    />
  );
};
